import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Turnstile from "../components/Turnstile";
import { Truck } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password, captchaToken);
      nav("/app");
    } catch (e) {
      setErr(e.message || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:flex md:w-1/2 hero-gradient text-white items-center justify-center p-12">
        <div className="max-w-md">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-white/15 rounded-xl grid place-items-center backdrop-blur"><Truck size={26}/></div>
            <div className="text-2xl font-bold tracking-tight">Ritik Cargo Carriers</div>
          </div>
          <h1 className="text-4xl font-bold leading-tight mb-3">Move freight, not paperwork.</h1>
          <p className="text-sky-100 leading-relaxed">A complete multi-tenant Transport Management System — bookings, tracking, branches, agents, vehicles, reports and customer tracking, all in one place.</p>
          <ul className="mt-8 space-y-2 text-sm">
            <li>· Auto LR generation & complete consignment lifecycle</li>
            <li>· Real-time tracking timeline (Booked → Delivered)</li>
            <li>· Multi-branch, multi-vehicle, multi-agent</li>
            <li>· Role-based access: Admin, Manager, Operator</li>
          </ul>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="text-2xl font-bold text-slate-900 mb-1">Sign in</h2>
          <p className="text-sm text-slate-500 mb-6">Welcome back to Ritik Cargo Carriers</p>
          <label className="block mb-3">
            <span className="text-xs font-medium text-slate-600">Email</span>
            <input data-testid="login-email" type="email" value={email} onChange={e=>setEmail(e.target.value)} required
              className="w-full mt-1 px-3 py-2.5 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500"/>
          </label>
          <label className="block mb-4">
            <span className="text-xs font-medium text-slate-600">Password</span>
            <input data-testid="login-password" type="password" value={password} onChange={e=>setPassword(e.target.value)} required
              className="w-full mt-1 px-3 py-2.5 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500"/>
          </label>
          {err && <div className="text-sm text-red-600 mb-3" data-testid="login-error">{err}</div>}
          <Turnstile action="login" onVerify={setCaptchaToken} />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full py-2.5 rounded-md lt-btn-primary font-semibold disabled:opacity-60">
            {loading ? "Signing in..." : "Sign in"}
          </button>
          <div className="mt-5 text-center text-sm">
            <a href="/track" className="text-sky-700 hover:underline" data-testid="public-track-link-login">Track a shipment</a> · <a href="/" className="text-sky-700 hover:underline">Home</a>
          </div>
        </form>
      </div>
    </div>
  );
}
